export default {
      id: "flex-flexDirection-row-usage",
      viewBox: "0 0 40 40",
      url: "assets/" + "sprite.svg#flex-flexDirection-row-usage",
      toString: function () {
        return this.url;
      }
    }